setTimeout(() => {
    if (document.querySelector('.bsscommerce-ltsp-message')) {
        let quantitySelector = document.querySelector('.product-info__quantity-selector')
        if (quantitySelector) {
            quantitySelector.style.display = 'none'
        }
    }
}, 1000)

window.bssB2BHooks = window.bssB2BHooks || {
    actions: {},
    filters: {}
};
window.BSS_B2B = window.BSS_B2B || {};
window.BSS_B2B.addAction = (tag, callback) => {
    window.bssB2BHooks.actions[tag] = callback;
};
window.BSS_B2B.addFilter = (tag, value) => {
    window.bssB2BHooks.filters[tag] = value;
};
const handleCartCheckoutBtn = ({shopData, checkoutButton, Tax}) => {
    const defaultBtnCheckout = $(checkoutButton).parent().find("button[name='checkout']");
    if (defaultBtnCheckout.length > 0) {
        defaultBtnCheckout.css("display", "none");
        $("#bss-checkout").css("display", "block");
    }
};
window.BSS_B2B.addAction("fix_handle_cart_checkout_btn", handleCartCheckoutBtn);
BSS_B2B.customShowPriceQB = (totalPriceHTML, totalPriceItemEle) => {
    $(totalPriceItemEle)
        .closest("tr")
        .find(".cart-item-price2")
        .html(totalPriceHTML);
};
setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
            if (item.target.localName == 'cart-notification-drawer') {
                BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, false, false, false);
            }
        }
    })
    observer.observe(document.body, {
        childList: true,
        subtree: true
    })
}, 300)
setTimeout(() => {
    if (window.location.pathname === '/cart') {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
            cartDrawer.remove();
            BSS_B2B.cart.fixer(BSS_B2B.shopData, false, false)
        }
    }
}, 1000)
if (BSS_B2B) {
    window.addEventListener("cart_changed", () => {
        setTimeout(() => {
            let storeData = JSON.parse($("#bss-b2b-store-data").html());
            BSS_B2B.cart.fixer(storeData, null, false);
            BSS_B2B.handleCartCheckoutBtn(storeData);
        }, 500);
    });
    setTimeout(() => {
        const targetMiniCart = document.querySelector(".cart-drawer");
        if (targetMiniCart) {
            const mutationObserver = new MutationObserver((recordList, observe) => {
                BSS_B2B.cart.fixer(JSON.parse(document.getElementById("bss-b2b-store-data").innerHTML), false, false);
                setTimeout(() => {
                    BSS_B2B.handleCartCheckoutBtn(JSON.parse($("#bss-b2b-store-data").html()));
                }, 1000)
            });
            mutationObserver.observe(targetMiniCart, {attributes: true});
        }
    }, 500)
    setTimeout(() => {
        function handleButtonClick(e) {
            e.preventDefault();
            const $button = $(this);
            let oldText = $(this).text();
            $button.css({'pointer-events': 'none', 'opacity': '0.6'});
            $button.text("Loading ...");
            setTimeout(() => {
                $button.css({'pointer-events': 'unset', 'opacity': '1'})
                $button.text(oldText);
            }, 2000);
        }
        $(document).on('click dblclick', 'button[name="checkout"]', handleButtonClick);
    }, 500)
    BSS_B2B.customTriggerCheckoutBtn = function (checkoutBtn) {
        window.location.href = "/checkout";
    }
}